function requireAll(r) { r.keys().forEach(r); }
requireAll(require.context('../Scripts/jquery-validate/', true, /\.js$/));